module.exports = __webpack_public_path__ + "media/images/bg_form_section-f0f5e8b650b2c187825230098982d4c9.svg";